import React, { useEffect, useState } from 'react';
import noUiSlider from 'nouislider';
import 'nouislider/distribute/nouislider.css';

export const StepSlider = ({ onChange, step, name, min, max, minValue, maxValue, initalValue, valueType, currency, idSlider, idValue }) => {
  const [ isLoaded, setIsLoaded ] = useState(false);

  useEffect(() => {
    if (!isLoaded) {
      const rangeSlider = document.getElementById(idSlider);
      const rangeSliderValueElement = document.getElementById(idValue);
      const dollarSign = currency ? "$" : "";
  
      noUiSlider.create(rangeSlider, {
        start: [initalValue],
        step: step || 1,
        connect: "upper",
        range: {
            'min': [min],
            'max': [max]
        }
      });
      rangeSlider.noUiSlider.on('update', function (values, handle) {
        onChange({ target: { name, value: parseFloat(values[handle]) }});
        rangeSliderValueElement.innerHTML = dollarSign + parseFloat(values[handle]) + valueType;
      });
      setIsLoaded(true)
    }
  }, [currency, step, idSlider, idValue, initalValue, isLoaded, max, min, name, onChange, valueType])

  return (
    <div className="range-slider">
      <div className="range">
        <div id={idSlider} className="slider-range" />
        <div id={idValue} className="slider-range-value text-01-sky-blue-bold" />
      </div>
      <div className="range-values">
        <span className="text-05-navy-blue">{minValue}</span>
        <span className="text-05-navy-blue">{maxValue}</span>
      </div>
    </div>
  )
}